// 页面样式
import css from 'css/page/rank.scss'
// API
import {
  getRank
} from 'js/api/index'
// 公共方法
import {
  domObserver,
  headerInit,
  hotJudge,
  LoadGames,
  memberShip,
} from 'js/common/index'
// 工具方法
import * as utils from 'js/utils/index'

/**
 * DOM 事件初始化
 */
function bindEvts() {
  memberFormInit()
  loadMoreGame()
}

/**
 * 会员表单事件初始化
 */
function memberFormInit() {
  memberShip.closeForm.init()
  memberShip.forgetPwdFormInit({
    form: '.yui-memberform0-forgetpwd',
    mask: '.mask-member',
  })
  memberShip.loginFormInit({
    success: () => headerInit(),
    form: '.yui-memberform0-login',
    mask: '.mask-member',
  })
  memberShip.registerFormInit({
    form: '.yui-memberform0-register',
    mask: '.mask-member',
  })
}

/**
 * 关键词初始化
 */
function keyWordsInit() {
  let list = document.querySelector('.list-keywords ul')
  if (!list) {
    utils.log.e(`[keyWordsInit] DOM element whose selector's .list-keywords ul not found`)
    return
  }

  let obj = list.querySelector('.selected')

  if (obj) {
    list.prepend(obj)
  }
}

/**
 * 加载更多游戏
 */
function loadMoreGame() {
  let moreObj = document.querySelector('.yui-loadmore0')

  if (!moreObj) {
    utils.log.e(`[loadMoreGame] DOM element whose selector's .yui-loadmore0 not found.`)
    return
  }

  let target = document.querySelector('.sec-main .list')
  if (!target) {
    utils.log.e(`[loadMoreGame] DOM element whose selector's .sec-main .list not found.`)
    return
  }

  let pageIndex = 1 // 数据表页码
  let loadGames = new LoadGames({
    createNode,
  })

  $(moreObj).one('click', handler)

  function handler() {
    loadGames.done(() => {
        $(moreObj).one('click', handler)
        pageIndex++
      })
      .failed(() => {
        $(moreObj).one('click', handler)
      })
      .completed(() => {
        $(moreObj).remove()
      })
      .start({
        api: getRank,
        data: {
          columns: 'description,id,logofile,thumnaillogofile,link,name,score,tags,proscore,filesize',
          descLen: '160',
          pageIndex,
          pageSize: 20,
          rankCode: moreObj.getAttribute('data-rankcode'),
          type: moreObj.getAttribute('data-type'),
        },
        loadingTxt: '正在加载...',
        moreObj,
        target,
      })
  }

  function createNode(o) {
    return $(`
      <li>
        <a class="yui-card0halign" href="${o.link}">
          <div class="yui-card0halign-iconbox">
            <img src="${ process.env.NODE_ENV === 'production' ? resourceprefix : SERVER_URL }${o.thumnaillogofile ? o.thumnaillogofile : o.logofile}" alt="" onerror="_global.imgErrHandler(this)">
          </div>
          <div class="yui-card0halign-infobox">
            <div class="high-layer">
              <span class="icon-base">${this.amt}</span>
              <span>${o.name}</span>
            </div>
            <div class="middle-layer">
              <span class="slot-lft">${o.tags}</span>
              <span class="slot-lft">${o.filesize || '--'}</span>
              <div class="${hotJudge(o.proscore)}">
                <span>热度${Number.parseInt(o.proscore)}℃</span>
                <svg class="icon yui-icon-flame0-red">
                  <use xlink:href="#icon-flame0"></use>
                </svg>
              </div>
            </div>
            <div class="low-layer">${o.description}</div>
          </div>
          <div class="yui-card0halign-actionbox">
            <svg class="icon yui-icon-arrow4-bluedown">
              <use xlink:href="#icon-arrow4" href="#icon-arrow4"></use>
            </svg>
          </div>
        </a>
      </li>
    `)[0]
  }
}

/**
 * 排行榜初始化
 */
function rankListInit() {
  $('.yui-cranklist0').on('mouseenter', 'li', function () {
    $(this).addClass('selected').siblings('.selected').removeClass('selected')
  })
}

/**
 * UI 初始化
 */
function uiInit() {
  keyWordsInit()
  rankListInit()
}

window._dataBus.get('domReadyObserver').subscribe(() => {
  uiInit()
  bindEvts()
})


// WEBPACK FOOTER //
// ./js/page/rank.js